/**
 * The Expedition Certified wordmark (Brendon, 24 September 2026; rules in the project folder's
 * `assets/brand/README.md`): upright Crimson Pro at weight 550, tracking -0.005em, the font's own
 * kerning. The font file is a self-hosted subset holding only the letters of this one name, so it
 * never sets other text.
 *
 * It is the Academy's own branding. A tenant takes it only when it is the Academy itself: exactly
 * this name, endorsed, and no logo of its own. Every operator's name and logo, and white label,
 * keep their existing treatment.
 */
export const ACADEMY_NAME = 'Expedition Certified';

export const WORDMARK_FAMILY = 'Crimson Pro Wordmark';
export const WORDMARK_FONT_URL = '/fonts/crimson-pro-wordmark-550.woff2';

/**
 * The approved study lockup: a 60px mark box, 67.666px type and a 12px gap. Every placement scales
 * those three together from the mark box.
 */
export const WORDMARK_TYPE_RATIO = 67.666 / 60;
export const WORDMARK_GAP_RATIO = 12 / 60;

export function usesAcademyWordmark(tenant: {
  name: string;
  brand_mode: string;
  logo_url?: string | null | undefined;
}): boolean {
  return tenant.name === ACADEMY_NAME && tenant.brand_mode === 'endorsed' && !tenant.logo_url;
}
